import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=7a1cd026&scoped=true&"
import script from "./addArticle.vue?vue&type=script&lang=js&"
export * from "./addArticle.vue?vue&type=script&lang=js&"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=7a1cd026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1cd026",
  null
  
)

export default component.exports